(function() {
  function formatDate(date) {
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }

  function renderTimelineDates() {
    var today = new Date();
    document.querySelectorAll('[data-hj-date]').forEach(function(el) {
      var type = el.dataset.hjDate;
      var date;
      if (type === 'today') {
        date = today;
      } else if (type === 'tomorrow') {
        date = new Date(today);
        date.setDate(today.getDate() + 1);
      } else if (type === 'arrive') {
        var days = parseInt(el.dataset.hjDays || '5', 10);
        date = new Date(today);
        date.setDate(today.getDate() + days);
      } else {
        return;
      }
      el.textContent = formatDate(date);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderTimelineDates);
  } else {
    renderTimelineDates();
  }
})();
